import { createSlice } from '@reduxjs/toolkit';

export const sucursalSlice = createSlice({
	name: 'sucursales',
	initialState: [],
	reducers: {
		setSucursales: (state, action) => {
			return action.payload;
		},
		addSucursal: (state, action) => {
			state.push(action.payload);
		},
		updateSucursal: (state, action) => {
			const index = state.findIndex((sucursal) => sucursal.id === action.payload.id);
			if (index !== -1) {
				state[index] = action.payload;
			}
		},
		deleteSucursal: (state, action) => {
			return state.filter((sucursal) => sucursal.id !== action.payload);
		},
	},
});

export const { setSucursales, addSucursal, updateSucursal, deleteSucursal } = sucursalSlice.actions;

export default sucursalSlice.reducer;
